import { render } from "./FormLegalComponent.vue?vue&type=template&id=0e8eec94"
import script from "./FormLegalComponent.vue?vue&type=script&lang=js"
export * from "./FormLegalComponent.vue?vue&type=script&lang=js"

import "./FormLegalComponent.vue?vue&type=style&index=0&id=0e8eec94&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__